import {GetHealthCities} from 'domain/usecases';
import {RemoteGetHealthCities} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthCities = (): GetHealthCities =>
	new RemoteGetHealthCities(
		makeBFFApiUrl(BookingFlowEndPoints.healthCities),
		makeAuthorizeHttpClientDecorator(),
	);
